function parseSheets(data) {
  const useIntegers = true;

  const responseObj = {};
  const rows = [];
  const columns = {};
  for (let i = 0; i < data.feed.entry.length; i++) {
    const entry = data.feed.entry[i];
    const keys = Object.keys(entry);
    const newRow = {};
    const queried = true;
    for (let j = 0; j < keys.length; j++) {
      const gsxCheck = keys[j].indexOf("gsx$");
      if (gsxCheck > -1) {
        const key = keys[j];
        const name = key.substring(4);
        const content = entry[key];
        let value = content.$t;
        // if (value.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        //   queried = true
        // }
        if (useIntegers === true && !isNaN(value)) {
          value = Number(value);
        }
        newRow[name] = value;
        if (queried === true) {
          // eslint-disable-next-line no-prototype-builtins
          if (!columns.hasOwnProperty(name)) {
            columns[name] = [];
            columns[name].push(value);
          } else {
            columns[name].push(value);
          }
        }
      }
    }
    if (queried === true) {
      rows.push(newRow);
    }
  }
  responseObj.columns = columns;
  responseObj.rows = rows;

  return responseObj;
}

export default parseSheets;
